goog.provide('el8.appchart.layout');

goog.require('el8.app.pageLayout');
goog.require('el8.template.appchart.layout');
goog.require('el8.util.consts');
goog.require('el8.util.dom');

el8.appchart.layout = (function() {
    var DIVIDER_WIDTH = el8.util.consts.DIVIDER_WIDTH;
    var PANE_CUSHION = el8.util.consts.PANE_CUSHION;
    var MAX_LHS_WIDTH = el8.util.consts.MAX_LHS_WIDTH;
    var MIN_LHS_WIDTH = el8.util.consts.MIN_LHS_WIDTH;
    var FOUR_P_WIDTH = el8.util.consts.FOUR_P_WIDTH;
    var LHS_SPLIT = el8.util.consts.LHS_SPLIT;
    var MIN_CHART_FEED_WIDTH = el8.util.consts.MIN_CHART_FEED_WIDTH;
    var THREE_PANE_AVAIL_WIDTH = el8.util.consts.THREE_PANE_AVAIL_WIDTH;
    var WRITE_SEE_COLLAPSE_WIDTH = el8.util.consts.WRITE_SEE_COLLAPSE_WIDTH;

    var that = {};

    // State variables to track which type of view we are actually in
    that._displayMode = 'feed';        // 'form' or 'feed' ('form' -> 3P is primary)
    that._viewMode = 'big';            // 'small' or 'big' (2P or 3P)
    that._threePaneAvailable = null;   // whether 3P mode is available
    that._thirdPaneOpen = false;       // whether a 3P form is actually open (visit note or otherwise)
    that._fourthPaneOpen = false;      // whether a 4P (currently providers' list) is open
    that._reportsOpen = false;         // whether the reports dialog is open

    // cached selectors
    var $mainFeedDivider = $('#main-feed-divider');
    var $chartFormDivider = $('#chart-form-divider');
    var $fourthPane = $('#fourth-pane');
    var $fourthPaneAnimateWrapper = $('#fourth-pane-wrapper');
    var $patientFeedContainer = $('#patient-feed-container');
    var $writeSeeBar = $('#chart-write-see-bar');
    var $chartFormContainer = $('#chart-form-container');
    var $mainFeedContainer = $('#main-feed-container');
    var $chartFeedContainer = $('#chart-feed-container');
    var $chartCenterContainer = $('#chart-feed-contents');
    var $mainContent = $('#main-content');
    var $chartFeedNavigator;

    /**
     * External API
     */
     that.setup = function() {

        that._updateThreePaneAvailable();
        that._initViewMode();
        that._layoutPanes(true); // no animation for intial setup

        el8.app.pageLayout.addResizeListener(function() {
            that._updateThreePaneAvailable();
            that._layoutPanes(true); // no animation on auto-resize
        });

        $patientFeedContainer.on('click', '#main-feed-divider',  function(e) {
            that.displayFeed();
            return false;

        }).on('click', '#chart-form-divider',  function(e) {
            that.displayForm();
            return false;
        });

        $(window).trigger('resize');
    };

    that.showThirdPane = function() {
        that._thirdPaneOpen = true;
        that.displayForm();
    };
    that.hideThirdPane = function() {
        that._thirdPaneOpen = false;
        that.displayFeed();
    };

    that.showReports = function($elt) {
        that._reportsOpen = true;
        if (that._thirdPaneOpen) {
            that._layoutPanes();
        } else {
            that._layoutForReports($elt);
        }
    };

    that.hideReports = function($elt) {
        that._reportsOpen = false;
        that._layoutPanes();

        // Recenter on elt again if we have it since we might be-unlinearizing here and the user
        // could lose context
        if ($elt && $elt.length) {
            var $mainFeedContainer = $("#main-feed-container");
            var offset =
                -($(window).height() / 2) +
                ($(".chart-feed-navigator").outerHeight(true) || 0) +
                75;

            $mainFeedContainer.scrollTo($elt, { offset: offset });
        }
    };

    // used externally to swap the primary element when in 2P mode
    // and internally to implement show/hideThirdPane
    that.displayForm = function() {
        that._displayMode = 'form';
        that._layoutPanes();
    };
    that.displayFeed = function() {
        that._displayMode = 'feed';
        that._layoutPanes();
    };

    // manipulate 2P vs. 3P mode
    that.toggleViewMode = function() {
        if (that._viewMode ==='big') {
            that.changeViewMode('small');
        } else {
            that.changeViewMode('big');
        }
        return that._viewMode;
    };
    that.changeViewMode = function(mode) {
        if (mode === 'big') {
            if (that.isThreePaneAvailable()) {
                that._setViewMode(mode);
                that._layoutPanes();
            }
        } else if (mode === 'small') {
            that._setViewMode(mode);
            that._layoutPanes();
        }
    };

    that.updateHeight = function() {

        var innerHeight = el8.app.pageLayout.getAppInnerHeight();

        // Size up reference board panel (LHS) height
        $('#refBoardContainer')
            .height(innerHeight-($('#refBoardContainerB').outerHeight(true) || 0));

        $fourthPane.height(innerHeight);

        // Size up patient feed panel (RHS) height
        var patientFeedHeight = innerHeight - ($('.el8ShortcutBar').outerHeight(true) || 0);
        $patientFeedContainer.height(patientFeedHeight);
        $('#main-feed-divider, #chart-form-divider').height(patientFeedHeight);
        $mainFeedContainer.height(patientFeedHeight);
        $chartFormContainer.height(patientFeedHeight);

    };

    that.showFourthPane = function(completeFn) {
        if (that._viewMode === 'big') {
            // in 3P mode, the chart form will float over the chart feed
            that._floatChartForm();
        }
        that._updateWriteSeeBar(true); // if we're going to have to shrink the write see bar, do it now

        var initialPositions = that._getCurrentPositions(); // cache these for use in the step fn

        $mainContent.addClass('el8Main4POpen'); // add a drop-shadow
        $fourthPaneAnimateWrapper.outerWidth(0).show()
            .animate({ width: FOUR_P_WIDTH }, {
                duration: el8.util.consts.QUICK_ANIMATION,
                step: function(now, fx) {
                    // animate the margin-right up, as the width increases
                    $mainContent.css('margin-right', now);

                    // if $mainContent is at its min width, let it start floating over the LHS and
                    // return so we don't decrease its width any further
                    if (initialPositions.mainContentWidth - now < MIN_CHART_FEED_WIDTH) {
                        if(!$mainContent.hasClass('el8MainFloating')) { $mainContent.addClass('el8MainFloating'); }
                        return;
                    }

                    // adjust the chart feed, third pane, etc. as the 4P appears
                    var widthIncrement = now * -1;
                    that._fourPAnimateStep(initialPositions, widthIncrement);
                },
                complete: function() {
                    that._fourPAnimateComplete(true);
                    if (completeFn) { completeFn(); }
                }
            });
    };
    that.hideFourthPane = function(completeFn) {

        if (that._thirdPaneOpen && that._displayMode === 'form') {
            // if the chart form is open/visible, let it float along
            that._floatChartForm();
        }

        var initialPositions = that._getCurrentPositions(); // cache these for use in the step fn

        // animate the fourth pane's width down to 0; as we go, we'll
        // also update $mainContent and the 3P if it's open, in the step fn
        $fourthPaneAnimateWrapper.animate({ width: 0 }, {
            duration: el8.util.consts.QUICK_ANIMATION,
            step: function(now, fx) {
                // animate the margin-right down, as the width decreases
                $mainContent.css('margin-right', now);

                // if $mainContent is still floating on the LHS, return;
                // as margin-right decreases, it will move to the right
                if (initialPositions.mainContentOffset > (FOUR_P_WIDTH - now)) { return; }

                // if we got here, we don't need to be floating anymore
                if ($mainContent.hasClass('el8MainFloating')) {
                    $mainContent.css('right', '').removeClass('el8MainFloating');
                }

                // finally, adjust the chart feed, third pane, etc., as the 4P disappears
                var widthIncrement = FOUR_P_WIDTH - now - initialPositions.mainContentOffset;
                that._fourPAnimateStep(initialPositions, widthIncrement);
            },
            complete: function() {
                $fourthPaneAnimateWrapper.hide();
                $mainContent.css({ 'margin-right': '', 'width': '' }).removeClass('el8Main4POpen');

                that._fourPAnimateComplete(false);
                if (completeFn) { completeFn(); }
            }
        });
    };

    that.triggerThreePaneChange = function() {
        $(document).trigger('el8_threePaneChange',
            [that._threePaneAvailable, that._viewMode]);
    };
    that.triggerRefBoardChange = function() {
        $(document).trigger('el8_refBoardChange');
    };
    that.isThreePaneAvailable = function() {
        return that._threePaneAvailable;
    };
    that.getViewMode = function() {
        return that._viewMode;
    };
    that.isThirdPaneVisible = function() {
        return (that._viewMode === 'big' && that._thirdPaneOpen) ||
            (that._viewMode ==='small' && that._thirdPaneOpen
                && that._displayMode === 'form');
    };
    that.getMainFeedOffsets = function() {
        return $patientFeedContainer.offset();
    };
    /** End external API */

    that._layoutForReports = function ($elt) {
        // $elt is the element to (potientially) re-center on. Not used for RA, for example.

        var PANE_CUSHION = el8.util.consts.PANE_CUSHION;
        var MAX_LHS_WIDTH = el8.util.consts.MAX_LHS_WIDTH;
        var MIN_LHS_WIDTH = el8.util.consts.MIN_LHS_WIDTH;
        var LHS_SPLIT = el8.util.consts.LHS_SPLIT;
        var MIN_CHART_FEED_WIDTH = el8.util.consts.MIN_CHART_FEED_WIDTH;
        var REPORTS_DIALOG_WIDTH = el8.util.consts.REPORTS_DIALOG_WIDTH;

        var $mainFeedContainer = $('#main-feed-container');
        var $chartCenterContainer = $('#chart-feed-contents');
        var $mainContent = $('#main-content');
        var totalWidth = el8.app.pageLayout.getAppWidth();

        // No recalc needed at 2010px or greater
        if (totalWidth < 2010) {

            // If (1/3rd of the total width - 10px cushion) is between the MIN and MAX widths, use it
            var refBoardWidth = Math.max(MIN_LHS_WIDTH,
                                        Math.min(LHS_SPLIT * totalWidth - 2 * PANE_CUSHION, MAX_LHS_WIDTH));

            // Compute the desired width of the chart feed based on the space remaining
            var chartFeedWidth = totalWidth - refBoardWidth - REPORTS_DIALOG_WIDTH - PANE_CUSHION;
            if (chartFeedWidth < MIN_CHART_FEED_WIDTH) {
                // If the calculated feed width is too small, make the LHS smaller by the needed
                // space down to it's minimum.
                refBoardWidth = refBoardWidth - (MIN_CHART_FEED_WIDTH - chartFeedWidth) - PANE_CUSHION * 2;

                // If that's still not enough space, set minimum widths on both (which happens around
                // 1400px and below)
                if (refBoardWidth < MIN_LHS_WIDTH) { refBoardWidth = MIN_LHS_WIDTH; }
                chartFeedWidth = MIN_CHART_FEED_WIDTH;
            }

            // Set widths
            $('#refBoard').outerWidth(refBoardWidth);
            $('#refBoardContainer').outerWidth(refBoardWidth);
            $mainContent.css('margin-left', refBoardWidth);
            $chartCenterContainer.addClass('el8Feed3rdPaneOpen');
            $mainFeedContainer.outerWidth(chartFeedWidth).show();
            $('.chart-feed-navigator').outerWidth(chartFeedWidth).show();

            that.updateHeight();
            that.triggerRefBoardChange();

            // Has the LHS+FEED width fallen below 1200px? We might have linearized the feed,
            // so center on the selected element so it doesn't get lost
            if ($elt && $elt.length && refBoardWidth + chartFeedWidth < 1200) {
                // center on selected elt since we probably changed position
                var offset =
                    -($(window).height() / 2) +
                    ($(".chart-feed-navigator").outerHeight(true) || 0) +
                    15;
                $mainFeedContainer.scrollTo($elt, { offset: offset });
            }
        }
    };

    that._layoutPanes = function(noAnimate) {
        if (that._reportsOpen && !that._thirdPaneOpen) {
            that._layoutForReports();
            return;
        }

        if (el8.app.pageLayout.getAppInnerWidth() <= 900 && that._fourthPaneOpen) {
            $mainContent.addClass('el8MainFloating').css('width', MIN_CHART_FEED_WIDTH);
        } else {
            $mainContent.removeClass('el8MainFloating').css('width', '');
        }
        that._updateWriteSeeBar(false);
        that._updateDividers();
        if (that._viewMode === 'big') {
            if (that._displayMode === 'form') {
                that._setThreePane();
            } else if (that._displayMode === 'feed') {
                that._setTwoPane(noAnimate);
            }
        } else if (that._viewMode === 'small') {
            that._setTwoPane(noAnimate);
        }
        that._updateNavigator();
    };

    that._setViewMode = function(mode) {
        if (mode !== that._viewMode) {
            that._viewMode = mode;
            that._updateDividers();
        } else {
            that._viewMode = mode;
        }
    };

    that._initViewMode = function() {
        that.isThreePaneAvailable() ?
            that._setViewMode('big') : that._setViewMode('small');
    };
    that._updateNavigator = function() {
        var $navHolder = $('#chart-feed-navigator-holder');
        var width = $navHolder.width();
        if (!$chartFeedNavigator || !$chartFeedNavigator.length) {
            $chartFeedNavigator = $('.chart-feed-navigator', $navHolder);
        }

        if (that._fourthPaneOpen) {
            // subtract padding if 4th pane open
            $chartFeedNavigator.outerWidth(width - ($chartFeedNavigator.innerWidth() - $chartFeedNavigator.width()));
        } else {
            $chartFeedNavigator.outerWidth(width);
        }

        // resize graph
        el8.appchart.mainFeeds.chartTimeline.resizeGraph();
    };
    that._updateWriteSeeBar = function(aboutToOpen4P) {
        // if opening the 4P will cause the bar to collapse, we want to support starting the collapse early
        var collapseWidth = (aboutToOpen4P) ?
            WRITE_SEE_COLLAPSE_WIDTH + FOUR_P_WIDTH : WRITE_SEE_COLLAPSE_WIDTH;
        if ($patientFeedContainer.width() < collapseWidth) {
            $writeSeeBar.addClass('el8WriteSeeCollapse');
        } else {
            $writeSeeBar.removeClass('el8WriteSeeCollapse');
        }
    };
    that._updateDividers = function() {

        if (that._viewMode === 'big') {
            // Hide the toggle handlers
            $mainFeedDivider.hide();
            $chartFormDivider.hide();

        } else if (that._viewMode === 'small') {

            if (that._displayMode === 'form') {
                if (!$mainFeedDivider.contents().length) {
                    $mainFeedDivider.html(el8.template.appchart.layout.chartFeedDivider());
                }
                $mainFeedDivider.show();
                $chartFormDivider.hide();

            } else if (that._displayMode === 'feed') {
                if (that._thirdPaneOpen) {
                    $chartFormDivider
                        .html(el8.template.appchart.layout.thirdPaneDivider({
                            name: el8.appchart.mgr.thirdpane.getPaneName()
                        }))
                        .show();
                } else {
                    $chartFormDivider.hide();
                }
                $mainFeedDivider.hide();
            }
        }
    };

    that._setThreePane =  function() {

        var totalWidth = el8.app.pageLayout.getAppWidth();
        var refBoardWidth = Math.max(MIN_LHS_WIDTH,
            Math.min(LHS_SPLIT*totalWidth - 2*PANE_CUSHION, MAX_LHS_WIDTH));

        // chart feed + chart form split 50/50 the remaining space subject
        // to MIN: 545 (because of timeline)
        var chartFeedWidth = (totalWidth - refBoardWidth) / 2 - PANE_CUSHION;
        if (chartFeedWidth < MIN_CHART_FEED_WIDTH) {
            // will stay above 250 because min window width requirement is 1435, so fine
            refBoardWidth = refBoardWidth - 2*(MIN_CHART_FEED_WIDTH - chartFeedWidth);
            chartFeedWidth = MIN_CHART_FEED_WIDTH;
        }
        var chartFormWidth = chartFeedWidth;

        $('#refBoard').outerWidth(refBoardWidth);
        $('#refBoardContainer').outerWidth(refBoardWidth);
        $mainContent.css('margin-left', refBoardWidth);

        $('#main-feed-divider, #chart-form-divider').outerWidth(DIVIDER_WIDTH-1);

        $chartCenterContainer.addClass('el8Feed3rdPaneOpen');

        $mainFeedContainer
            .outerWidth(chartFeedWidth)
            .show();
        $chartFormContainer.outerWidth(chartFormWidth);
        if (that._fourthPaneOpen) {
            that._floatChartForm().show();
        } else {
            that._unfloatChartForm().show();
        }

        that.updateHeight();

        that.triggerRefBoardChange();
    };
    that._setTwoPane = function(noAnimate) {

        var totalWidth = el8.app.pageLayout.getAppWidth();
        var refBoardWidth = Math.max(MIN_LHS_WIDTH,
            Math.min(LHS_SPLIT*totalWidth - 2*PANE_CUSHION, MAX_LHS_WIDTH));

        $('#refBoard').outerWidth(refBoardWidth);
        $('#refBoardContainer').outerWidth(refBoardWidth);
        $mainContent.css('margin-left', refBoardWidth);

        var patientFeedWidth = $patientFeedContainer.width();
        var paneWidth = patientFeedWidth -
            ((that._viewMode === 'big') ? 0 : DIVIDER_WIDTH);

        $('#main-feed-divider, #chart-form-divider').outerWidth(DIVIDER_WIDTH-1);
        // don't call _floatChartForm because we don't want to reset 'left' here, or the two-pane will jump out
        $chartFormContainer.addClass('el8FloatingChartForm');
        // don't animate the very first jump from 0->DIVIDIER_WIDTH when the divider shows up. Looks goofy.
        if ($chartFormContainer.position().left < DIVIDER_WIDTH) {
            $chartFormContainer.css('left', DIVIDER_WIDTH);
        }
        $chartCenterContainer.removeClass('el8Feed3rdPaneOpen');

        if (that._displayMode === 'form') {
            if (noAnimate) {
                $chartFormContainer.show().css({
                    width: paneWidth,
                    left: DIVIDER_WIDTH
                });
            } else {
                 // move from off-screen or 3P location to DIVIDER_WIDTH
                $chartFormContainer.show().outerWidth(paneWidth);

                if (Math.abs($chartFormContainer.position().left - DIVIDER_WIDTH) < PANE_CUSHION) {
                    // we had a 3P floating over the chart feed - just jump it to the right position
                    $chartFormContainer.css('left', DIVIDER_WIDTH);
                } else {
                    // animate from off screen
                    $chartFormContainer.animate({left: DIVIDER_WIDTH}, {
                        duration: el8.util.consts.QUICK_ANIMATION
                    });
                }
            }

        // default is to show feed
        } else if (that._displayMode === 'feed') {
            // If no 3rd Pane open, don't need to leave space for
            // chart form divider
            var modPaneWidth = !that._thirdPaneOpen ? patientFeedWidth : paneWidth;
            $mainFeedContainer.outerWidth(modPaneWidth).show();
            if (!that._thirdPaneOpen) {
                $chartFormContainer.hide(); // we don't need to move the form off screen if it's being formally closed
            } else {
                var curLeftPos = $chartFormContainer.position().left;
                // we use the noAnimate option on initial setup and for auto-resizes
                if (noAnimate || (Math.abs(curLeftPos - modPaneWidth) < PANE_CUSHION)) {
                    $chartFormContainer.css('left', modPaneWidth);
                } else {
                     // move off-screen
                    $chartFormContainer.animate({left: modPaneWidth}, {
                        duration: el8.util.consts.QUICK_ANIMATION
                    });
                }
            }
        }

        that.updateHeight();

        that.triggerRefBoardChange();
    };
    that._updateThreePaneAvailable = function() {
        var newThreePaneAvailable = (el8.app.pageLayout.getAppWidth() > THREE_PANE_AVAIL_WIDTH);
        if (that._threePaneAvailable !== newThreePaneAvailable) {
            that._threePaneAvailable = newThreePaneAvailable;
            // If 3P not available, force viewMode to "small"
            if (!that._threePaneAvailable) {
                that._setViewMode('small');
            }
            // Trigger appropriate custom events
            that.triggerThreePaneChange();
        }
    };

    that._floatChartForm = function() {
        return $chartFormContainer.css('left', '').addClass('el8FloatingChartForm');
    };
    that._unfloatChartForm = function() {
        return $chartFormContainer.removeClass('el8FloatingChartForm').css('left', 0);
    };

    that._fourPAnimateComplete = function(isOpen) {
        that._fourthPaneOpen = isOpen;
        that._updateThreePaneAvailable();
        that._layoutPanes(true);
        if (that.isThirdPaneVisible()) { el8.appchart.mgr.thirdpane.adjustSize(); }
    };
    that._fourPAnimateStep = function(initials, widthIncrement) {
        $mainContent.css('width', initials.mainContentWidth + widthIncrement);
        if (!$chartFeedNavigator || !$chartFeedNavigator.length) {
            $chartFeedNavigator = $('.chart-feed-navigator', $chartFeedContainer);
        }

        if (!that._thirdPaneOpen) {
            // if the 3P's not open, adjust the chart feed as the 4P moves
            $mainFeedContainer.css('width', initials.mainFeedWidth + widthIncrement);
            $chartFeedNavigator.css('width', $chartFeedContainer.width());
        } else if (that._viewMode === 'small') {
            // if it is open but we're in 2P view, adjust the active view's width
            if (that._displayMode === 'form') {
                $chartFormContainer.css('width', initials.chartFormWidth + widthIncrement);
            } else {
                $mainFeedContainer.css('width', initials.mainFeedWidth + widthIncrement);
                $chartFeedNavigator.css('width', $chartFeedContainer.width());
                // make sure the off-screen 3P moves along with the 4P
                $chartFormContainer.css('left', initials.chartFormLeft + widthIncrement);
            }
        }
    };
    // cache this and pass it to that._fourPAnimateStep to avoid recalculating on every animation step
    that._getCurrentPositions = function() {
        return {
            mainFeedWidth: $mainFeedContainer.width(),
            mainContentWidth: $mainContent.width(),
            mainContentOffset: $mainContent.position().left * -1, // when we care about the offset, it's a negative 'left'
            chartFormWidth: $chartFormContainer.width(),
            chartFormLeft: $chartFormContainer.position().left
        };
    };

    return that;

})();
